export const colors = {
  background:    '#f7f5f2',
  primary:       '#2d1b5e',
  primaryLight:  '#f0eaff',
  surface:       '#ffffff',
  border:        '#e8e4f0',
  textPrimary:   '#1a1a2e',
  textSecondary: '#4a4a6a',
  textMuted:     '#7c6faf',
}

export const memberColors = {
  slate:   '#64748b',
  rose:    '#f43f5e',
  amber:   '#f59e0b',
  emerald: '#10b981',
  sky:     '#0ea5e9',
  violet:  '#8b5cf6',
  pink:    '#ec4899',
  orange:  '#f97316',
  teal:    '#14b8a6',
  indigo:  '#6366f1',
}

export const memberColorKeys = Object.keys(memberColors)

// 12 visually distinct colors for calendars and events
export const EVENT_PALETTE = [
  '#ef4444', // red
  '#f97316', // orange
  '#eab308', // yellow
  '#22c55e', // green
  '#10b981', // emerald
  '#06b6d4', // cyan
  '#3b82f6', // blue
  '#6366f1', // indigo
  '#8b5cf6', // violet
  '#a855f7', // purple
  '#ec4899', // pink
  '#64748b', // slate
]
